
const React = require('react');
const HeaderMixin = require('./mixins/header').HeaderMixin;

const HeaderDetailsView = React.createClass({
    mixins: [HeaderMixin],

    render: function() {
        const org = this.getOrganization();
        const loc = this.getLocation();
        const productCategory = (this.props.Wholesaler && this.props.Retailer)?'Wholesale & Retail':(this.props.Wholesaler?'Wholesale Only':(this.props.Retailer?'Retail Only':null));
        let mailto = this.getFarmerMailTo();
        return (
            <div className="header-inner-wrap">
                <div className="header-title">
                    {this.props.Conventional?<a href="https://www.cngfarming.org/who_we_are" target="_blank"><img src="/static/CNGlogowhitecirclesm.png" style={{float: 'right',width: '90px',marginLeft: '20px'}}/></a>:null}
                    <span className="title notranslate">{org.Name}</span><br/>
                    <span>{productCategory}</span><br/>
                    {this.props.ContactURL? <a href={this.formatURL(this.props.ContactURL)} target="_blank">{this.props.ContactURL}</a> : null }

                </div>
                <div className="header-actions">
                    <div className="group notranslate">
                        {this.locationFieldIsVisible('Address') ? <span>{loc.Address}</span> : null}
                        {(this.locationFieldIsVisible('City') || this.locationFieldIsVisible('State') || this.locationFieldIsVisible('Zip'))? <span>{(loc.City?loc.City:'') + ' ' + (loc.State?loc.State:'') + ' ' + (loc.Zip?loc.Zip:'')}</span> : null}
                        {this.countryFieldIsVisible() ? <span>{loc.Country}</span> : null}
                        {this.locationFieldIsVisible('ContactEmail') ? <span><a href={mailto}>{loc.ContactEmail}</a></span>: null}
                        {this.locationFieldIsVisible('ContactPhone') ? <span><a href={"tel:" + loc.ContactPhone}>{loc.ContactPhone}</a></span> : null}
                    </div>
                </div>
                
            </div>
        )
    }
});

exports.HeaderDetailsView = HeaderDetailsView;